import { Module } from "wrapper6";

var $ = jQuery;

export default class Search extends Module {

	ready(app) {

        const SEARCH_ICON = document.querySelector('.svg-icon--search svg');
        const SEARCH_BAR = document.querySelector('.search-bar');
        
        SEARCH_ICON.addEventListener('click', () => {

            SEARCH_BAR.classList.toggle('show');

            if($(SEARCH_BAR).hasClass('show')) {
                // Focus after timeout to make sure it happens after any transitions
                // Seems a bit wonky, but it checks out atm
                setTimeout( () => {
                    $(SEARCH_BAR).find('input[type="search"]').focus();
                }, 250);
            }
        });
    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_search.js